import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import BookCateringCTA from 'caterers/components/BookCateringCTA';
import CatererDeliverySchedule from 'caterers/components/CatererDeliverySchedule';
import Map from 'shared/components/Map';

const BookCateringCTAContainer = ({
  unsignedCatererAddress,
  deliverySchedule,
  catererName,
  citySlug,
}) => {
  const theme = useTheme();
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { t } = useTranslation('caterers');

  return (
    <StyledContainer mobile={mobile}>
      {unsignedCatererAddress && (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Map address={unsignedCatererAddress} catererName={catererName} />
          <Typography mt={2} component="div">
            <Box
              display="inline"
              fontWeight={theme.typography[mobile ? 'body1' : 'h3'].fontWeight}
            >
              {t('caterer.catererAddress')}
            </Box>
            {unsignedCatererAddress}
          </Typography>
        </Box>
      )}
      {deliverySchedule && (
        <CatererDeliverySchedule deliverySchedule={deliverySchedule} />
      )}
      <BookCateringCTA catererName={catererName} citySlug={citySlug} />
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)`
  display: ${(props) => (props.mobile ? 'flex' : 'grid')};
  flex-direction: column;
  grid-template-columns: 1fr 1fr;
  column-gap: ${(props) => props.theme.spacing(6)}px;
  row-gap: ${(props) => props.theme.spacing(2)}px;
  margin-top: ${(props) => props.theme.spacing(2)}px;
`;

export default BookCateringCTAContainer;
